/* Millo Coins — cylindrical CSS 3D edge, 14 October 2026.
 * The original PNG stays untouched on the front; a second readable copy is on
 * the reverse. Only the moving coin images listed below are wrapped.
 */
(function () {
  'use strict';

  var STYLE_ID = 'mg-coin-volume-css';
  if (document.getElementById(STYLE_ID)) return;

  var SELECTORS = [
    '.hx-st2 .co .md > img',
    '.hx-tabs .ins > img',
    '.rg-insw > img.rg-ins',
    '.gx-lv li.new .cc > img'
  ];
  var SELECTOR = SELECTORS.join(',');
  var SIDES = 32;
  var SOURCE_ATTRIBUTES = ['src', 'srcset', 'sizes'];
  var METALS = {
    miembro: '#33343b', mg: '#b88653', gang: '#d09d9c', mynol: '#cfba93',
    gantel: '#d2ac41', milloganter: '#b9c1c9', club: '#b7dbea'
  };
  var testAngle = null;
  var query = new URLSearchParams(window.location.search);
  var isPreview = query.has('preview_theme_id') || /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
  var requestedAngle = query.get('coin_angle');

  var css = `
html .mgcv {
  --mgcv-depth: 5.5px;
  --mgcv-half-depth: 2.75px;
  --mgcv-radius: 24px;
  --mgcv-facet-width: 4.9px;
  --mgcv-metal: #ddd1b2;
  --mgcv-edge-strength: 100%;
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  flex: 0 0 auto;
  perspective: 800px;
  perspective-origin: 50% 50%;
  transform-style: preserve-3d;
  overflow: visible;
  pointer-events: none;
}
html .mgcv-body {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  transform: rotateY(0deg);
  transform-origin: 50% 50%;
  transform-style: preserve-3d;
}
/* Grouping properties stay off the body so the edge is genuinely 3D. */
html .mgcv-face {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
html .mgcv-front { transform: translateZ(var(--mgcv-half-depth)); }
html .mgcv-back { transform: rotateY(180deg) translateZ(var(--mgcv-half-depth)); }
html .mgcv img.mgcv-image {
  position: absolute !important;
  inset: 0 !important;
  display: block !important;
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  object-fit: contain !important;
  animation: none !important;
  transform: none !important;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
html .mgcv-edge {
  --mgcv-surface: color-mix(in srgb, var(--mgcv-metal) var(--mgcv-edge-strength), #000);
  position: absolute;
  display: block;
  left: 50%;
  top: 50%;
  width: var(--mgcv-facet-width);
  height: var(--mgcv-depth);
  margin-left: calc(var(--mgcv-facet-width) / -2);
  margin-top: calc(var(--mgcv-depth) / -2);
  transform: rotateZ(var(--mgcv-angle)) translateY(calc(var(--mgcv-radius) * -1)) rotateX(90deg);
  transform-origin: 50% 50%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  background:
    repeating-linear-gradient(90deg, #ffffff26 0 .6px, #00000024 .6px 1.35px, transparent 1.35px 2.3px),
    linear-gradient(0deg,
      color-mix(in srgb, var(--mgcv-surface) 65%, #000) 0%,
      color-mix(in srgb, var(--mgcv-surface) 67%, #fff) 13%,
      var(--mgcv-surface) 40%,
      color-mix(in srgb, var(--mgcv-surface) 70%, #fff) 86%,
      color-mix(in srgb, var(--mgcv-surface) 65%, #000) 100%);
}
html .hx-tabs .lock .mgcv { --mgcv-edge-strength: 55%; }
html .rg-c.lock .mgcv { --mgcv-edge-strength: 70%; }
html .mgcv[data-coin-volume-kind="purchase"] {
  display: inline-block;
  width: .62em;
  height: .62em;
  vertical-align: middle;
}
html .mgcv[data-coin-volume-kind="balance"] .mgcv-body {
  animation: mgcv-balance-spin 7s cubic-bezier(.5, 0, .3, 1) 3s infinite;
  will-change: transform;
}
@keyframes mgcv-balance-spin {
  0%, 70% { transform: rotateY(0deg); }
  90%, 100% { transform: rotateY(360deg); }
}
html .mgcv[data-coin-volume-kind="purchase"] .mgcv-body {
  animation: mgcv-one-spin 1.2s cubic-bezier(.5, 0, .3, 1) .3s both;
}
@keyframes mgcv-one-spin {
  from { transform: rotateY(0deg); }
  to { transform: rotateY(360deg); }
}
@media (hover: hover) and (pointer: fine) {
  html .hx-tabs button:hover .mgcv-body,
  html .rg-c:hover .mgcv-body {
    animation: mgcv-one-spin 1s cubic-bezier(.3, .7, .2, 1) both;
  }
}
html .hx-tabs button:focus-visible .mgcv-body,
html .rg-c:focus-within .mgcv-body {
  animation: mgcv-one-spin 1s cubic-bezier(.3, .7, .2, 1) both;
}
@media (prefers-reduced-motion: reduce) {
  html .mgcv .mgcv-body {
    animation: none !important;
    transition: none !important;
    transform: rotateY(0deg);
    will-change: auto;
  }
}
/* Finite DOM-only angles allow side/reverse QA without runtime globals. */
html .mgcv[data-coin-volume-angle] .mgcv-body {
  animation: none !important;
  transition: none !important;
}
html .mgcv[data-coin-volume-angle="0"] .mgcv-body { transform: rotateY(0deg) !important; }
html .mgcv[data-coin-volume-angle="90"] .mgcv-body { transform: rotateY(90deg) !important; }
html .mgcv[data-coin-volume-angle="180"] .mgcv-body { transform: rotateY(180deg) !important; }
html .mgcv[data-coin-volume-angle="270"] .mgcv-body { transform: rotateY(270deg) !important; }
html .mgcv[data-coin-test-angle] .mgcv-body {
  animation: none !important;
  transition: none !important;
  transform: rotateY(var(--mgcv-test-angle)) !important;
}
`;

  var style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  function kindFor(image) {
    if (image.closest('.hx-st2 .co')) return 'balance';
    if (image.closest('.hx-tabs')) return 'tab';
    if (image.closest('.rg-insw')) return 'gift';
    return 'purchase';
  }

  function metalFor(image) {
    var source = image.getAttribute('src') || '';
    var slug = source.match(/mg-lv-(miembro|mg|gang|mynol|gantel|milloganter|club)(?:[-.]|$)/i);
    if (slug) return METALS[slug[1].toLowerCase()];
    if (/mg-coin-oro-640|mg-millo-coin|mg-coin(?:-64)?\.png/i.test(source)) return '#ddd1b2';
    if (/oro|gold|leyenda/i.test(source)) return METALS.gantel;
    return '#ddd1b2';
  }

  function shade(hex, factor) {
    var channels = [1, 3, 5].map(function (position) {
      return Math.max(0, Math.min(255, Math.round(parseInt(hex.slice(position, position + 2), 16) * factor)));
    });
    return 'rgb(' + channels.join(',') + ')';
  }

  function colorEdge(host, image) {
    var metal = metalFor(image);
    host.style.setProperty('--mgcv-metal', metal);
    host.querySelectorAll('.mgcv-edge').forEach(function (panel, index) {
      var angle = index * 2 * Math.PI / SIDES;
      var light = .61 + .24 * Math.cos(angle - .55);
      panel.style.setProperty('--mgcv-metal', shade(metal, light));
    });
  }

  function sizeEdge(host, width) {
    width = width || host.clientWidth;
    if (!width || Math.abs(width - (host._mgcvWidth || 0)) < .1) return;
    host._mgcvWidth = width;
    /* The transparent margin of these exact PNGs leaves a disc at ~96%.
     * Facets sit on the inscribed regular polygon, with a subpixel overlap. */
    var radius = width * .48;
    var depth = width * .11;
    host.style.setProperty('--mgcv-depth', depth.toFixed(3) + 'px');
    host.style.setProperty('--mgcv-half-depth', (depth / 2).toFixed(3) + 'px');
    host.style.setProperty('--mgcv-radius', (radius * Math.cos(Math.PI / SIDES)).toFixed(3) + 'px');
    host.style.setProperty('--mgcv-facet-width', (2 * radius * Math.sin(Math.PI / SIDES) + .25).toFixed(3) + 'px');
  }

  var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { sizeEdge(entry.target, entry.contentRect.width); });
  }) : null;

  /* Keep the original image in place until its 3D detail is close enough to
   * see. This avoids creating 32 facets + a reverse for every distant card. */
  var pendingImages = new Set();
  var intersectionObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var image = entry.target;
      intersectionObserver.unobserve(image);
      pendingImages.delete(image);
      if (image.isConnected && image.matches(SELECTOR)) wrap(image);
    });
  }, { rootMargin: '400px', threshold: 0 }) : null;

  function prepare(image) {
    if (!image.parentNode || image.closest('.mgcv, .g-coin, .mw-rain')) return;
    var kind = kindFor(image);
    /* Balance and purchase coins have timed feedback animations. Preserve
     * their original start time, and keep preview angles deterministic. */
    if (!intersectionObserver || testAngle !== null || kind === 'balance' || kind === 'purchase') {
      wrap(image);
    } else if (!pendingImages.has(image)) {
      pendingImages.add(image);
      intersectionObserver.observe(image);
    }
  }

  function syncSource(image) {
    var host = image.closest('.mgcv');
    if (!host) return;
    var back = host.querySelector('.mgcv-back img');
    if (!back) return;
    SOURCE_ATTRIBUTES.forEach(function (attribute) {
      var value = image.getAttribute(attribute);
      if (value === null) {
        if (back.hasAttribute(attribute)) back.removeAttribute(attribute);
      } else if (back.getAttribute(attribute) !== value) {
        back.setAttribute(attribute, value);
      }
    });
    colorEdge(host, image);
  }

  function wrap(image) {
    if (!image.parentNode || image.closest('.mgcv, .g-coin, .mw-rain')) return;
    var host = document.createElement('span');
    var body = document.createElement('span');
    var front = document.createElement('span');
    var back = document.createElement('span');
    var reverse = image.cloneNode(false);
    host.className = 'mgcv';
    host.setAttribute('data-coin-volume-kind', kindFor(image));
    body.className = 'mgcv-body';
    if (testAngle !== null) {
      host.setAttribute('data-coin-test-angle', String(testAngle));
      body.setAttribute('data-coin-test-angle', String(testAngle));
      host.style.setProperty('--mgcv-test-angle', testAngle + 'deg');
    }
    front.className = 'mgcv-face mgcv-front';
    back.className = 'mgcv-face mgcv-back';
    back.setAttribute('aria-hidden', 'true');
    reverse.removeAttribute('id');
    reverse.removeAttribute('data-coin-volume-front');
    reverse.alt = '';
    reverse.setAttribute('aria-hidden', 'true');
    reverse.classList.add('mgcv-image');
    image.classList.add('mgcv-image');
    image.setAttribute('data-coin-volume-front', '');
    back.appendChild(reverse);
    body.appendChild(front);
    body.appendChild(back);
    for (var index = 0; index < SIDES; index++) {
      var panel = document.createElement('span');
      panel.className = 'mgcv-edge';
      panel.setAttribute('aria-hidden', 'true');
      panel.style.setProperty('--mgcv-angle', (index * 360 / SIDES) + 'deg');
      body.appendChild(panel);
    }
    host.appendChild(body);
    image.parentNode.insertBefore(host, image);
    front.appendChild(image);
    colorEdge(host, image);
    sizeEdge(host);
    if (resizeObserver) resizeObserver.observe(host);
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(SELECTOR)) prepare(node);
    node.querySelectorAll(SELECTOR).forEach(prepare);
  }

  function cleanDetached(node) {
    if (!node || node.nodeType !== 1 || node.isConnected) return;
    if (intersectionObserver) {
      pendingImages.forEach(function (image) {
        if (node === image || node.contains(image)) {
          intersectionObserver.unobserve(image);
          pendingImages.delete(image);
        }
      });
    }
    if (resizeObserver) {
      if (node.matches('.mgcv')) resizeObserver.unobserve(node);
      node.querySelectorAll('.mgcv').forEach(function (host) { resizeObserver.unobserve(host); });
    }
  }

  function mount() {
    /* Shopify can retain the preview cookie after removing preview_theme_id.
     * Check after DOM readiness so its actual preview bar is available. */
    isPreview = isPreview || !!document.querySelector('iframe#PBarNextFrame');
    if (isPreview && requestedAngle !== null && /^-?\d+(?:\.\d+)?$/.test(requestedAngle)) {
      var numericAngle = Number(requestedAngle);
      if (Number.isFinite(numericAngle)) testAngle = Math.max(0, Math.min(360, numericAngle));
    }
    var club = document.querySelector('.mc');
    /* Shopify's containing section also catches replacement of the club DOM.
     * Within it, only newly added subtrees and front source attributes are read. */
    var root = (club && club.closest('[id^="shopify-section-"]')) || club || document.querySelector('main') || document.body;
    if (!root) return;
    scan(root);
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.type === 'attributes') {
            if (record.target.hasAttribute('data-coin-volume-front')) syncSource(record.target);
            return;
          }
          record.removedNodes.forEach(cleanDetached);
          record.addedNodes.forEach(scan);
        });
      });
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: SOURCE_ATTRIBUTES });
    }
    if (!resizeObserver) {
      window.addEventListener('resize', function () {
        root.querySelectorAll('.mgcv').forEach(function (host) { sizeEdge(host); });
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
